<template>
  <div>
    <TsProCardStepperSkeleton v-if="procardStore.loading.draft" />
    <div v-else>
      <TsTypography
        appendClass="text-natural-grey mb-4 text-base"
        :text="useTranslation('authorizedSignatoryContactMessage' , 'De onderstaande contactgegevens worden gebruikt om u te identificeren als tekenbevoegde van het bedrijf.')"
      />

      <TsTypography
        appendClass="text-natural-grey mb-4 text-base"
        :text="useTranslation('pro-cardApplicationMessage' , 'Een PRO-kaartaanvraag kan alleen worden ingevuld door een bevoegd persoon.')"
      />

      <TsRow noGutter>
        <TsColumn appendClass="lg:is-4 max-md:is-12">
          <TsInput
            v-model="procardStore.application_form.account_holder_name"
            @input="procardStore.errors.account_holder_name = ''"
            @keydown.enter.exact.prevent="handleSubmit"
            :placeholder="useTranslation('nameOfAccountHolder' , 'Naam van de hoofdrekeninghouder')"
            data-testid="pro-card-application-authorized-person-name-input"
          />
        </TsColumn> 
      </TsRow>
      <TsTypography
        append-class="text-sm text-danger pl-2"
        v-if="procardStore.errors.account_holder_name.length > 0"
        data-testid="pro-card-application-authorized-person-error"
        >{{ procardStore.errors.account_holder_name }}
      </TsTypography>
      <TsProCardFormBottomBar
        @back="emit('back')"
        @next="handleSubmit"
        @draft="emit('draft')"
        :next-button="{
          disabled: !procardStore.application_form.account_holder_name,
          isLoading: procardStore.loading.next_button,
        }"
        :save-button="{
          isLoading: procardStore.loading.save_button,
        }"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
const procardStore = useProCardStoreV2();
const baseDataTestId = "pro-card-application-authorized-person-";

const TsProCardStepperSkeleton = defineAsyncComponent(
    () => import('~/components/organisms/TsProCardStepperSkeleton.vue')
);

const TsProCardFormBottomBar = defineAsyncComponent(
    () => import('~/components/procard/TsProCardFormBottomBar.vue')
);

type Props = {
  dataTestid?: string;
};

const props = withDefaults(defineProps<Props>(), {});

const emit = defineEmits<{
  back: any;
  next: any;
  draft: any;
}>();

function handleSubmit() {
  if (!validateNameInput(procardStore.application_form.account_holder_name)) {
    procardStore.errors.account_holder_name =
    useTranslation('procard-Error' , 'De naam van de rekeninghouder moet een geldige naam zijn. Controleer het nogmaals');
    return;
  }
  emit("next");
}
</script>
